import colors from './colors'

export default {
  fontFamily: 'Gilroy',
  h1: {
    fontSize: '4.5rem',
    fontWeight: 800,
    color: colors.black,
  },
  h2: {
    fontSize: '2.6rem',
    fontWeight: 800,
    color: colors.black,
  },
  h3: {
    fontSize: '2.2rem',
    fontWeight: 800,
    color: colors.greys.veryDark,
  },
  h4: {
    fontSize: '1.4rem',
    fontWeight: 700,
    color: colors.greys.veryDark,
  },
  h5: {
    fontSize: '1.2rem',
    fontWeight: 700,
    color: colors.greys.light,
  },
  h6: {
    fontSize: '1.1rem',
    fontWeight: 700,
    color: colors.greys.dark,
  },
  subtitle1: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: colors.greys.light,
  },
  subtitle2: {
    fontSize: '0.9rem',
    fontWeight: 700,
    color: colors.greys.light,
    textDecoration: 'line-through',
  },
  body1: {
    fontSize: '0.95rem',
    fontWeight: 700,
    color: colors.greys.medium,
  },
  body2: {
    fontSize: '0.95rem',
    fontWeight: 600,
    color: colors.greys.medium,
  },
  button: {
    fontSize: '1.1rem',
    fontWeight: 700,
    textTransform: 'none',
  },
  caption: {
    textDecoration: 'line-through',
  },
  overline: {
    textDecoration: 'line-through',
  },
}
